import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'adc-modal',
  templateUrl: './adc-modal.component.html',
  styleUrls: ['./adc-modal.component.scss'],
  standalone: false
})
export class AdcModalComponent {
  @Input() toggle!: boolean;
  @Input() data: any;
  @Output() action = new EventEmitter();

  constructor() {}


  ngOnInit(): void {
    // this.data = this.dataService.data;
    // this.action = new EventEmitter();
  }

  btnAction(btnName: string) {
    this.action.emit(btnName);
  }

  copied: boolean = false;

}
